import { RadioGroupProps } from './interfaces';

const RadioGroup: React.FC<RadioGroupProps> = ({ question, selectedAnswerId, onAnswerChange }) => {
  const groupId = `question-${question.id}`;

  return (
    <div aria-required="true" className="mt-3">
      <p data-hj-suppress className="text-base text-primary-2 pb-4">
        {question.question}
      </p>
      <div role="radiogroup" aria-required="true" className="space-y-2">
        {question.answerOptions.map(answer => (
          <label
            key={answer.id}
            className="flex items-center cursor-pointer hover:bg-gray-1 rounded-md transition-colors "
          >
            <div className="relative">
              <input
                type="radio"
                data-hj-suppress
                name={groupId}
                value={answer.id}
                checked={selectedAnswerId === answer.id}
                onChange={() => onAnswerChange(question.id, answer.id)}
                className="sr-only"
              />
              <div
                className={`h-6 w-6 rounded-full border-2 transition-colors ${
                  selectedAnswerId === answer.id ? 'bg-primary-1 border-primary-1' : 'border-gray-300 bg-white'
                }`}
              >
                {selectedAnswerId === answer.id && (
                  <div className="h-3 w-3 bg-black rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
                )}
              </div>
            </div>
            <span data-hj-suppress className="text-sm text-primary-2 flex-1 ml-3">
              {answer.option}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
